<template>
  <div class="app-view-personal-data">
    <slot name="txtBefore">Persönliche Daten</slot>
    <div class="personal-data" v-if="personalData.person">
      <b-row class="salutation">
        <b-col md="" sm="12" class="label">
          <slot name="labelSalutation"> Anrede</slot>
        </b-col>
        <b-col md="" sm="12" class="value">
          <slot :name= "`salutation${personalData.person.gender}`" ></slot>
        </b-col>
      </b-row>
      <b-row class="firstName">
        <b-col md="" sm="12" class="label">
          <slot name="labelFirstName">Vorname</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{personalData.person.firstName}}</b-col>
      </b-row>
      <b-row class="lastName">
        <b-col md="" sm="12" class="label">
          <slot name="labelLastName">Nachname</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{personalData.person.lastName}}</b-col>
      </b-row>
      <b-row class="streetNumber">
        <b-col md="" sm="12" class="label">
          <slot name="labelStreetNumber">Straße / Hausnr.</slot>
        </b-col>
        <b-col md="" sm="12" class="value">
          <span class="street">{{personalData.person.address.street}}</span>
          <span class="houseNumber">{{personalData.person.address.houseNumber}}</span>
        </b-col>
      </b-row>
      <b-row class="supplement" v-if="personalData.person.address.supplement != null">
        <b-col md="" sm="12" class="label">
          <slot name="labelSupplement">Adresszusatz</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{personalData.person.address.supplement}}</b-col>
      </b-row>
      <b-row class="zipCity">
        <b-col md="" sm="12" class="label">
          <slot name="labelZipCity">PLZ / Ort</slot>
        </b-col>
        <b-col md="" sm="12" class="value">
          <span class="zip">{{personalData.person.address.zip}}</span>
          <span class="city">{{personalData.person.address.city}}</span>
        </b-col>
      </b-row>
      <b-row class="birthDate">
        <b-col md="" sm="12" class="label">
          <slot name="labelBirthDate">Geburtsdatum</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{personalData.person.birthDate}}</b-col>
      </b-row>
      <b-row class="email">
        <b-col md="" sm="12" class="label">
          <slot name="labelEmail">E-Mail Addresse</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{personalData.person.email}}</b-col>
      </b-row>
    </div>
    <slot name="txtAfter"></slot>

  </div>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'PersonalData',
  props: {
    personalData: {
      type: Object
    }
  },
  components: { BRow, BCol }
}
</script>
